export default "__VITE_ASSET__DzWUhIxq__"